const { registerVueComponent } = require("../../vvuejs/vueRegister.mjs");

registerVueComponent('vform17_multi_upload:notification', 'FMultiUploadNotification', () => import('./components/FMultiUploadNotification.vue'))
